export default __webpack_public_path__ + "static/media/repic.a19c1042.svg";